export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  ShowCssPerBreakpointIndicationsSideCart: 'specs.stores.ShowCssPerBreakpointIndicationsSideCart',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  UseProductThumbnailWithWowImage: 'specs.stores.UseProductThumbnailWithWowImage',
  FixHandleCreateCheckoutError: 'specs.ecom.FixHandleCreateCheckoutError',
  UseDeliveryOptionsLibInCart: 'specs.ecom.UseDeliveryOptionsLibInCart',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SupportDeliveryProfilesPhase2: 'specs.stores.SupportDeliveryProfilesPhase2',
  FixCouponCss: 'specs.ecom.FixCouponCss',
  EmptyCartA11yFix: 'specs.ecom.EmptyCartA11yFix',
  SideCartCouponAndNote: 'specs.ecom.SideCartCouponAndNote',
  SideCartNote: 'specs.ecom.SideCartNote',
  UseEcommerceSettingsInCart: 'specs.ecom.UseEcommerceSettingsInCart',
  ClientFormattingForPrices: 'specs.ecom.ClientFormattingForPrices',
  UseAdditionalEcommerceSettings: 'specs.ecom.UseAdditionalEcommerceSettings',
  UsePayableCurrencies: 'specs.ecom.UsePayableCurrencies',
  CartButtonBIEvents: 'specs.ecom.CartButtonBIEvents',
  DeprecatePaypalOnlyFlowInCart: 'specs.ecom.DeprecatePaypalOnlyFlowInCart',
  FixExpressWrongTotalAmount: 'specs.ecom.FixExpressWrongTotalAmount',
  SideCartEditor3SettingsPanel: 'specs.ecom.SideCartEditor3SettingsPanel',
  StopUsingPaymentMethodsInCart: 'specs.ecom.StopUsingPaymentMethodsInCart',
  MoveGetClientConfigToControllerFactory: 'specs.ecom.MoveGetClientConfigToControllerFactory',
  UseNewControllerFactoryInSideCart: 'specs.ecom.UseNewControllerFactoryInSideCart',
  UseNewControllerFactoryInCart: 'specs.ecom.UseNewControllerFactoryInCart',
  SkipCreateCheckoutFromCartForV2: 'specs.ecom.SkipCreateCheckoutFromCartForV2',
  ExpressCheckoutButtonsSkeleton: 'specs.ecom.ExpressCheckoutButtonsSkeleton',
  PreloadOnCartCheckoutButton: 'specs.ecom.PreloadOnCartCheckoutButton',
  SendBiFromDeliveryDropdown: 'specs.ecom.SendBiFromDeliveryDropdown',
  RemoveBackgroudColorCartItemThumbnail: 'specs.ecom.RemoveBackgroudColorCartItemThumbnail',
  FixExpressCheckoutButtonOnEditor: 'specs.ecom.FixExpressCheckoutButtonOnEditor',
  MoveCartToViewerContext: 'specs.ecom.MoveCartToViewerContext',
  SupportMembershipOnlineWithOfflineRemainderPaymentOption:
    'specs.ecom.SupportMembershipOnlineWithOfflineRemainderPaymentOption',
  ShowModalWhenNoPremiumForExpressOnCart: 'specs.ecom.ShowModalWhenNoPremiumForExpressOnCart',
  FreeDeliveryCouponTextOnCart: 'specs.ecom.FreeDeliveryCouponTextOnCart',
  FixTypingTextInNoteFieldIsBuggy: 'specs.ecom.FixTypingTextInNoteFieldIsBuggy',
  SendBIForPromoCodeAndNoteDisplay: 'specs.ecom.SendBIForPromoCodeAndNoteDisplay',
  DontUseLineItemEnricherInCartAndCheckout: 'specs.ecom.DontUseLineItemEnricherInCartAndCheckout',
  ShowSkeletonOnCartSSR: 'specs.ecom.ShowSkeletonOnCartSSR',
  FixCartNoteAutoFocus: 'specs.ecom.FixCartNoteAutoFocus',
  AddSlotsToSideCart: 'specs.ecom.AddSlotsToSideCart',
  BuyerNoteDebounceUpdate: 'specs.ecom.BuyerNoteDebounceUpdate',
  SupportSubscriptionsInPurchaseFlow: 'specs.ecom.SupportSubscriptionsInPurchaseFlow',
  FixSecureCheckoutBadgeColor: 'specs.ecom.FixSecureCheckoutBadgeColor',
} as const;
